import { render } from "./PianoDetail.vue?vue&type=template&id=9d31b8aa"
import script from "./PianoDetail.vue?vue&type=script&lang=js"
export * from "./PianoDetail.vue?vue&type=script&lang=js"

import "./PianoDetail.vue?vue&type=style&index=0&id=9d31b8aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__